"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pnlFunctions = void 0;
const volatilitySmile_1 = require("../calculationsCore/volatilitySmile");
const optionPricer_1 = require("../optionPricer");
const types_1 = require("../types");
/**
 * Functions that calculate pnl in settlement currency
 */
exports.pnlFunctions = {
    [types_1.PositionType.Future]: (position, ticker, simulatedPoint, termStructure, currencyType, isOffsetActive) => {
        const entryPrice = isOffsetActive
            ? ticker.markPrice
            : position.averagePrice;
        const expirePtBtc = position.amount / entryPrice - position.amount / simulatedPoint;
        const { r, T } = termStructure[position.instrument];
        const exitPrice = simulatedPoint * Math.exp(r * T);
        const todayPtBtc = position.amount / entryPrice - position.amount / exitPrice;
        const todayPt = currencyType === types_1.CurrencyType.CRYPTO
            ? todayPtBtc
            : todayPtBtc * simulatedPoint;
        const expirePt = currencyType === types_1.CurrencyType.CRYPTO
            ? expirePtBtc
            : expirePtBtc * simulatedPoint;
        return { todayPt, expirePt };
    },
    [types_1.PositionType.InversePerpetual]: (position, ticker, simulatedPoint, termStructure, currencyType, isOffsetActive) => {
        const entryPrice = isOffsetActive
            ? ticker.markPrice
            : position.averagePrice;
        const factor = ticker.markPrice / ticker.indexPrice;
        const res = (factor * simulatedPoint - entryPrice) * position.amountCurrency;
        return { todayPt: res, expirePt: res };
    },
    [types_1.PositionType.Option]: (position, ticker, simulatedPoint, termStructure, currencyType, isOffsetActive) => {
        const { r, T } = termStructure[position.instrument];
        const { strike, direction: optionType } = (0, volatilitySmile_1.getOptionInstrumentParts)(position.instrument);
        const t = T <= 0 ? 0.000001 : T;
        const todayPtUSD = (0, optionPricer_1.black76Price)(optionType, simulatedPoint, strike, ticker.volatility / 100, t, r);
        const discounted = simulatedPoint * Math.exp(-r * T);
        if (currencyType === types_1.CurrencyType.FIAT) {
            const entryPrice = isOffsetActive
                ? ticker.markPrice * ticker.indexPrice
                : position.averagePrice * ticker.indexPrice;
            const todayPtMinusPremium = (todayPtUSD - entryPrice) * position.amount;
            const expiryPtUsd = optionType === types_1.OptionType.CALL
                ? (Math.max(0, discounted - strike) - entryPrice) * position.amount
                : (Math.max(0, strike - discounted) - entryPrice) * position.amount;
            const todayPt = todayPtMinusPremium;
            const expirePt = expiryPtUsd;
            return { todayPt, expirePt };
        }
        else {
            const entryPrice = isOffsetActive
                ? ticker.markPrice
                : position.averagePrice;
            const todayPt = (todayPtUSD / discounted - entryPrice) * position.amount;
            const expirePt = optionType === types_1.OptionType.CALL
                ? (Math.max(0, discounted - strike) / discounted - entryPrice) *
                    position.amount
                : (Math.max(0, strike - discounted) / discounted - entryPrice) *
                    position.amount;
            return { todayPt, expirePt };
        }
    },
    [types_1.PositionType.LinearFuture]: (position, ticker, simulatedPoint, termStructure, currencyType, isOffsetActive) => {
        return { todayPt: -1, expirePt: -1 };
    },
    [types_1.PositionType.LinearOption]: (position, ticker, simulatedPoint, termStructure, currencyType, isOffsetActive) => {
        const { r, T } = termStructure[position.instrument];
        const { strike, direction: optionType } = (0, volatilitySmile_1.getOptionInstrumentParts)(position.instrument);
        const todayPtUSD = (0, optionPricer_1.black76Price)(optionType, simulatedPoint, strike, ticker.volatility / 100, T, r);
        const entryPrice = isOffsetActive
            ? ticker.markPrice * ticker.indexPrice
            : position.averagePrice * ticker.indexPrice;
        const todayPtMinusPremium = (todayPtUSD - entryPrice) * position.amount;
        const discounted = simulatedPoint * Math.exp(-r * T);
        const expiryPtUsd = optionType === types_1.OptionType.CALL
            ? (Math.max(0, discounted - strike) - entryPrice) * position.amount
            : (Math.max(0, strike - discounted) - entryPrice) * position.amount;
        return { todayPt: todayPtMinusPremium, expirePt: expiryPtUsd };
    },
    [types_1.PositionType.LinearPerpetual]: (position, ticker, simulatedPoint, termStructure, currencyType, isOffsetActive) => {
        const entryPrice = isOffsetActive
            ? ticker.markPrice
            : position.averagePrice;
        const factor = ticker.markPrice / ticker.indexPrice;
        const res = (factor * simulatedPoint - entryPrice) * position.amountCurrency;
        return { todayPt: res, expirePt: res };
    },
    [types_1.PositionType.VolatilityFuture]: (position, ticker, simulatedPoint, termStructure, currencyType, isOffsetActive) => {
        const entryPrice = isOffsetActive
            ? ticker.markPrice
            : position.averagePrice;
        const factor = ticker.markPrice / ticker.indexPrice;
        const res = (factor * simulatedPoint * ticker.indexPrice - entryPrice) *
            position.amountCurrency;
        return { todayPt: res, expirePt: res };
    },
};
